import { colors2, transition } from "oolib";
import styled from "styled-components";

const containerRadius = 1.2;

export const StyledContainer = styled.div`
  background: ${colors2.white};
  border-radius: ${containerRadius}rem;
  border: 1px solid ${colors2.grey10};
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  min-height: 20rem;
  ${transition("all 0.15s ease")};
`;

export const StyledHeader = styled.div`
  width: calc(100% + 3.2rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  font-family: Arial, sans-serif;
  margin-left: -1.6rem;
  margin-right: -1.6rem;
  padding: 0 1.6rem 1.2rem;
  border-bottom: 1px solid #0013320D;
  box-sizing: border-box;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 1 0 0;
`;

export const StyledHeaderRight = styled.div`
  display: flex;
  gap: 0.4rem;
  align-self: flex-start;
`;

export const StyledBody = styled.div`
  flex: 1;
  min-height: 0;

  /* Floating overlay scrollbar — pull the body 6px to the right and pad it
     back, so the scrollbar sits over the content instead of stealing layout. */
  margin-right: -6px;
  padding-right: 6px;

  /* Firefox: always reserve space, reveal thumb on hover */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  &:hover {
    scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
  }

  /* WebKit: fixed thin width, but thumb is transparent until hover */
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
    transition: background 0.2s ease;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.25);
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.4);
  }
`;
